<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<!-- 个人中心导航 -->
				<div class="ttshop_useright">
					<div class="ttshop_userights">
						<div class="ttshop_myorder clearfloat">
							<ul class="clearfloat">
								<li @click="orderTab(0)" :class="{active:currTab == 0}">全部订单</li>
								<li @click="orderTab(1)" :class="{active:currTab == 1}">待付款</li>
								<li @click="orderTab(2)" :class="{active:currTab == 2}">待发货</li>
								<li @click="orderTab(3)" :class="{active:currTab == 3}">待收货</li>
								<li @click="orderTab(4)" :class="{active:currTab == 4}">已完成</li>
							</ul>
						</div>
						<!-- 暂无订单展示 -->
						<div v-show="list.length == 0">
							<div class="ttshop_myorderzw" v-show="finish">
								<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
								<p>暂无订单</p>
							</div>
						</div>
						<!-- 订单列表 -->
						<div class="ttshop_myorderlist" v-show="list.length > 0">
							<div class="ttshop_myordertitle clearfloat">
								<div style="float:left;width:76%;" class="clearfloat">
									<div class="ttshop_myordertext">
										<div class="ttshop_myordertexter clearfloat">
											<p>商品信息</p>
										</div>
									</div>
									<div class="ttshop_myorderdj">
										<p>单价</p>
									</div>
									<div class="ttshop_myorderdj">
										<p>数量</p>
									</div>
									<div class="ttshop_myorderdjs">
										<p>收货人</p>
									</div>
									<div class="ttshop_myorderzfje">
										<p>支付总金额</p>
									</div>
								</div>
								<div class="ttshop_myordercz">
									<p>操作</p>
								</div>
							</div>
							<div class="ttshop_myordercon" v-for="(item,index) in list" :key="index">
								<div class="ttshop_myorderconed clearfloat">
									<div class="ttshop_myordercontitle clearfloat">
										<p>{{item.addtime}}</p>
										<p>订单号：<span>{{item.order_no}}</span></p>
										<div class="ttshop_myordercontitle_right">
											<p v-if="item.is_pay == 0">待支付</p>
											<p v-if="item.is_confirm != 1 && item.is_pay != 0">
												<template v-if="item.is_send == 0">待发货</template>
												<template v-if="item.is_send == 1">已发货</template>
											</p>
											<p v-if="item.is_confirm == 1">
												<template v-if="item.is_comment == 0">未评价</template>
												<template v-else>已完成</template>
											</p>
										</div>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop_myorderconlist clearfloat">
												<div class="ttshop_myorderconleft clearfloat">
													<div class="ttshop_orderimg">
														<img class="img-default" :src="item.detail.pic" alt="">
													</div>
													<div class="ttshop_ordertext">
														<h5>{{item.detail.goods_name}}</h5>
														<span v-for="(attr,ids) in item.detail.attr" :key="ids">{{attr.attr_name}}</span>
													</div>
												</div>
												<div class="ttshop_myorderdj">
													<p><span>{{item.detail.pay_integral}}</span>积分</p>
													<p v-if="item.detail.total_price > 0">￥<span>{{item.detail.total_price}}</span></p>
												</div>
												<div class="ttshop_myorderdj ttshop_myorderdjer">
													<p><span>{{item.detail.num}}</span></p>
												</div>
												<div class="ttshop_shr">
													<p>{{item.name}}</p>
												</div>
												<div class="ttshop_zfzje">
													<p><span>{{item.detail.pay_integral}}</span>积分</p>
													<p v-if="item.detail.total_price > 0">￥<span>{{item.detail.total_price}}</span></p>
												</div>
											</div>
											
										</div>
										<div class="ttshop_caozuos d-flex  align-items-center justify-content-center">
											<div>
												<p class="ttshop_ljzf" v-if="item.is_pay == 0" @click="openPayType(index)">立即支付</p>
												<p class="ttshop_ljzf" v-if="item.is_send == 1 && item.is_confirm == 0 && item.is_offline != 2" @click="confirmOrder(item.id)">确认收货</p>
												<p class="ttshop_ljzf" v-if="item.is_confirm == 1 && item.is_comment == 0" @click="goEvaluate(item.id)">评价晒单</p>
												<p class="ttshop_cztext" v-if="item.is_send == 0" @click="orderRevoke(item.id)">取消兑换</p>
												<p class="ttshop_cztext" @click="goOrderxq(item.order_no,item.id)">订单详情</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ttshop_pay">
			<el-dialog title="" :visible.sync="shopVisible" :before-close="payContTypeChange">
				<div class="pay-title d-flex align-items-center justify-content-center">微信支付￥{{payNum}}</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center ">
					<div id="qrcode" ref="qrcode"></div>
				</div>
			</el-dialog>
		</div>
		<Foot></Foot>
		<!-- 支付方式 -->
		<div class="ttshop_agreement" v-show="check_pay_type">
			<div class="ttshop_agreementbj" @click="closePayType"></div>
			<div class="ttshop_agreementbox">
				<div class="ttshop_agreementitle clearfloat">
					<h5>支付方式</h5>
					<div class="close" @click="closePayType"></div>
				</div>
				<div class="ttshop_agreementext">
					<template v-for="(payitem, payindex) in pay_type_list">
						<div class="pay-item clearfloat" :data-index="payindex" v-if="payitem.payment == 0 || payitem.payment == 1|| payitem.payment == 4" @click="checkPayType" :class="{active:payitem.payment == payment_type}">
							<div class="pay-img">
								<img class="img-default" :src="payitem.icon" alt />
							</div>
							<div class="pay-name">{{payitem.name}}</div>
							<div class="pay-select" v-show="payitem.payment == payment_type">
								<img class="img-default" src="../../assets/images/brand.png" alt />
							</div>
						</div>
					</template>
				</div>
				<div class="ttshop_agreementbut">
					<button @click="payOrder()">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "@/views/user/components/user_index";
	import QRCode from "qrcodejs2";
	let Base64 = require("js-base64").Base64;
	import "./integral.css";
	export default {
		components: {
			Header,
			Userheader,
			Foot,
		},
		data() {
			return {
				list: [],
				shopVisible: false,
				payNum: "",
				currTab: 0,
				time: "",
				finish: false,
				pay_type_list: [],
				payment_type: -1,
				check_pay_type: false, //支付方式
				order_index: -1, //选中的订单
			};
		},
		mounted() {
			if (this.$route.query.tab) {
				this.currTab = this.$route.query.tab;
			}
			this.getorderList();
		},
		methods: {
			//获取订单列表
			getorderList() {
				this.$loading();
				this.finish = false;
				let params = {
					status: this.currTab
				}
				this.$api.integarlOrderList(params).then((res)=>{
					this.$loading().close();
					this.list = res.data.list;
					this.finish = true;
					this.pay_type_list = res.data.pay_type_list;
					if (res.data.pay_type_list[0].payment == 0 || res.data.pay_type_list[0].payment == 1) {
						this.payment_type = res.data.pay_type_list[0].payment;
					}
				}).catch((err)=>{
					this.$loading().close();
					this.common.message(this,err)
				})
			},
			//切换
			orderTab(index) {
				if (this.currTab != index) {
					this.currTab = index;
					this.getorderList();
				}
			},
			//订单详情
			goOrderxq(order_no,id) {
				this.$router.push({
					path: "/integral_order_details",
					query: {
						order_no: order_no,
						id: id
					},
				});
			},
			//评价晒单
			goEvaluate(id) {
				this.$router.push({
					path: "/ttshop_evaluate",
					query: {
						id: id,
						type: "IN"
					}
				});
			},
			//取消订单
			orderRevoke(id) {
				let params = {
					order_id: id
				}
				this.$confirm("确定取消订单？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$api.integarlRevoke(params).then((res) => {
						this.$message({
							type: "success",
							message: res.msg,
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						this.getorderList();
					}).catch((err) => {
						this.common.message(this,err);
					});
				}).catch(() => {
					
				});
			},
			//确认收货
			confirmOrder(id) {
				let params = {
					order_id: id,
				}
				this.$confirm("是否确认已收到货物？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$api.integarlConfirm(params).then((res) => {
						this.$message({
							type: "success",
							message: res.msg,
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						this.getorderList();
					}).catch((err) => {
						this.common.message(this,err);
					});
				}).catch(() => {

				});
			},
			// 选择支付方式
			checkPayType(e) {
				let index = e.currentTarget.dataset.index;
				this.payment_type = this.pay_type_list[index].payment;
			},
			openPayType(index) {
				this.check_pay_type = true;
				this.order_index = index;
			},
			closePayType() {
				this.check_pay_type = false;
			},
			//支付
			payOrder() {
				let _this = this;
				let id = _this.list[_this.order_index].id;
				this.payNum = _this.list[_this.order_index].pay_price;
				let params = {
					id: id
				};
				_this.check_pay_type = false;
				if (_this.payment_type == 0||_this.payment_type == 4) { //支付宝
					let payurl = window.location.href;
					let payurls = payurl.split("#")[0] + '#/integral_order_list';
					// let payurls = "http://demo.oeob.net/#/integral_order_list";
					params.pay_type = "ALIPAY";
					params.return_url = payurls;
				} else if (_this.payment_type == 1) { //微信
					params.pay_type = "WECHAT_PAY"
				}
				_this.$api.integarlOrderSubmit(params).then((res) => {
					if (_this.payment_type == 0||_this.payment_type == 4) {
						window.sessionStorage.setItem('alipay_type', true);
						const div = document.createElement('div');
						div.innerHTML = res.data;
						document.body.appendChild(div);
						document.forms[0].submit();
					} else if (_this.payment_type == 1) {
						_this.shopVisible = true;
						_this.time = setInterval(() => {
							_this.orderStatus(res.res.order_no);
						}, 5000);
						let url = Base64.decode(res.res.code_url);
						setTimeout(function() {
							_this.qrcodeScan(url);
						}, 100);
					}
				}).catch((err) => {
					this.common.message(this,err)
				});
			},
			qrcodeScan(url) {
				this.$refs.qrcode.innerHTML = "";
				//生成二维码
				let qrcode = new QRCode("qrcode", {
					width: 150, // 二维码宽度
					height: 150, // 二维码高度
					text: url,
				});
			},
			// 支付二维码关闭
			payContTypeChange() {
				let that = this;
				that.$confirm("是否取消支付", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
				}).then(() => {
					that.shopVisible = false;
					clearInterval(this.time);
					this.getorderList();
				}).catch(() => {
					console.log("取消");
				});
			},
			//订单状态
			orderStatus(order) {
				if (this.shopVisible == false) {
					clearInterval(this.time);
				}
				let params = {
					order_no: "IN_" + order,
				}
				this.$api.orderStatus(params).then((res) => {
					if (res.code == 0) {
						clearInterval(this.time);
						this.$message({
							type: "success",
							message: res.msg,
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						this.shopVisible = false;
						this.getorderList();
					}
				}).catch((err) => {

				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	.pay-item {
		position: relative;
		width: 80%;
		background: #ffffff;
		border-radius: 2px;
		border: 1px solid #ebebeb;
		cursor: pointer;
		padding: 7px;
		box-sizing: border-box;
		margin: 0 auto 20px;

		&.active {
			border-color: #ff0e25;
		}

		.pay-img {
			float: left;
			width: 28px;
			height: 28px;
			border-radius: 2px;
			overflow: hidden;
		}

		.pay-name {
			float: left;
			padding-left: 12px;
			font-size: 14px;
			color: #333;
			line-height: 28px;
		}

		.pay-select {
			width: 12px;
			height: 12px;
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}

	// 支付方式
	.ttshop_agreement {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;

		.ttshop_agreementbj {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
		}

		.ttshop_agreementbox {
			width: 400px;
			height: 260px;
			background: #fff;
			position: fixed;
			top: 50%;
			left: 50%;
			margin-left: -200px;
			margin-top: -130px;
			border: 4px solid rgba(0, 0, 0, 0.4);
			border-radius: 4px;

			.ttshop_agreementitle {
				width: 100%;
				height: 40px;
				line-height: 40px;
				background: #f5f5f5;
				padding: 0 15px;
				box-sizing: border-box;

				h5 {
					float: left;
					font-size: 14px;
					color: #333;
					font-weight: bold;
				}

				.close {
					cursor: pointer;
					float: right;
					display: block;
					width: 20px;
					height: 20px;
					background: url(../../assets/images/ttshop_colse.png) center no-repeat;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					outline: none;
					margin-top: 10px;

					&:hover {
						background: url(../../assets/images/ttshop_colsed.png) center no-repeat;
					}
				}
			}

			.ttshop_agreementext {
				width: 100%;
				padding: 20px 20px 10px 20px;
				box-sizing: border-box;

				p {
					font-size: 14px;
					color: #333;
					text-indent: 2em;
					line-height: 26px;
				}
			}

			.ttshop_agreementbut {
				width: 100%;
				height: 60px;
				position: absolute;
				bottom: 0;
				left: 0;
				box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

				button {
					display: block;
					width: 180px;
					height: 40px;
					font-size: 14px;
					color: #fff;
					border-radius: 2px;
					outline: none;
					margin: 10px auto 0;
					border: 0;
					cursor: pointer;
					background: #ff0e25;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&:hover {
						box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
					}
				}
			}
		}
	}

	.orderlist {
		width: 100%;
		box-sizing: border-box;

		.listitem {
			float: left;
			width: 76%;
		}
	}

	.ttshop_useright {
		width: 100%;

		.ttshop_userights {
			padding: 16px 24px;
			box-sizing: border-box;
			background: #fff;

			.ttshop_myorder {
				width: 100%;
				margin-bottom: 16px;

				ul {
					float: left;

					li {
						float: left;
						font-size: 12px;
						color: #333;
						font-weight: 400;
						line-height: 12px;
						padding: 8px 0;
						box-sizing: border-box;
						margin-right: 24px;
						cursor: pointer;
						position: relative;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&::before {
							content: "";
							width: 0%;
							height: 2px;
							background: #ff0e25;
							position: absolute;
							bottom: -2px;
							left: 50%;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							transform: translateX(-50%);
							-moz-transform: translateX(-50%);
							-webkit-transform: translateX(-50%);
							-o-transform: translateX(-50%);
						}

						&:hover {
							color: #ff0e25;
						}

						&:hover::before {
							width: 100%;
						}

						&.active {
							font-weight: 600;
							color: #ff0e25;
						}

						&.active:before {
							width: 100%;
						}
					}

					& li:last-child {
						margin-right: 0;
					}
				}

				.ttshop_myorderseach {
					float: right;
					position: relative;

					input {
						width: 211px;
						height: 28px;
						border: 1px solid #ebebeb;
						font-size: 12px;
						color: #333;
						padding: 0 70px 0 8px;
						box-sizing: border-box;
						outline: none;
						border-radius: 2px;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:focus {
							border-color: #ff0e25;
						}
					}

					button {
						width: 62px;
						height: 26px;
						display: block;
						font-size: 12px;
						color: #333;
						text-align: center;
						position: absolute;
						top: 1px;
						right: 1px;
						border: 0;
						outline: none;
						background: #ebebeb;
						cursor: pointer;
						border-radius: 0 2px 2px 0;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							background: #ff0e25;
							color: #fff;
						}
					}
				}
			}

			.ttshop_myorderzw {
				width: 100%;
				min-height: 600px;
				background: #fff;
				padding-top: 180px;
				box-sizing: border-box;

				// display: none;
				img {
					display: block;
					width: 93px;
					height: 80px;
					margin: 0 auto 20px;
				}

				p {
					font-size: 14px;
					color: #333;
					text-align: center;
				}
			}

			.ttshop_myorderlist {
				width: 100%;

				.ttshop_myordertitle {
					width: 100%;
					background: #f5f5f5;
					height: 32px;
					margin-bottom: 20px;

					.ttshop_myordertext {
						float: left;
						width: 50%;
						padding-top: 8px;
						padding-left: 20px;
						box-sizing: border-box;

						.ttshop_myordertexter {
							display: table;
							// cursor: pointer;
							position: relative;

							p {
								float: left;
								font-size: 12px;
								color: #333;
							}

							i {
								float: left;
								width: 12px;
								height: 12px;
								margin-top: 2px;

								img {
									display: block;
									width: 100%;
								}
							}
						}
					}

					.ttshop_myorderdj {
						float: left;
						width: 11%;
						padding-top: 8px;
						box-sizing: border-box;

						p {
							font-size: 12px;
							color: #333;
							text-align: center;
						}
					}

					.ttshop_myorderdjs {
						float: left;
						width: 12%;
						padding-top: 8px;
						box-sizing: border-box;

						p {
							font-size: 12px;
							color: #333;
							text-align: center;
						}
					}

					.ttshop_myorderzfje {
						float: left;
						width: 16%;
						padding-top: 8px;
						box-sizing: border-box;

						p {
							font-size: 12px;
							color: #333;
							text-align: center;
						}
					}

					// .ttshop_myorderzt {
					//   float: left;
					//   width: 14%;
					//   padding-top: 8px;
					//   box-sizing: border-box;
					//   .ttshop_myorderzts {
					//     // cursor: pointer;
					//     p {
					//       float: left;
					//       font-size: 12px;
					//       color: #333;
					//     }
					//     i {
					//       float: left;
					//       width: 12px;
					//       height: 12px;
					//       margin-top: 2px;
					//       img {
					//         display: block;
					//         width: 100%;
					//       }
					//     }
					//   }
					// }
					.ttshop_myordercz {
						float: left;
						width: 24%;
						padding-top: 8px;
						box-sizing: border-box;

						p {
							font-size: 12px;
							color: #333;
							text-align: center;
						}
					}
				}

				.ttshop_myordercon {
					width: 100%;

					.ttshop_myorderconed {
						width: 100%;
						margin-bottom: 20px;

						.ttshop_myordercontitle {
							width: 100%;
							height: 32px;
							background: #f5f5f5;
							padding: 0 20px;
							box-sizing: border-box;
							line-height: 32px;

							p {
								float: left;
								font-size: 12px;
								color: #999;
								margin-right: 24px;

								span {
									font-size: 12px;
									color: #999;
								}

								strong {
									color: #333;
									font-weight: 500;
								}
							}

							& p:last-child {
								margin-right: 0;
								// float: right;
							}

							.ttshop_myordercontitle_right {
								float: right;
								line-height: 32px;

								.ttshop_cancel {
									font-size: 12px;
									color: #999;
									// margin-bottom: 2px;
								}

								.ttshop_over {
									font-size: 12px;
									color: #ff0e25;
									// margin-bottom: 2px;
								}

								strong {
									font-size: 12px;
									color: #ff0e25;
									font-weight: 400;
									cursor: pointer;
								}
							}
						}

						.ttshop_myorderconlist {
							width: 100%;
							min-height: 112px;
							border-left: 1px solid #ebebeb;
							border-bottom: 1px solid #ebebeb;
							box-sizing: border-box;
							border-right: 0;
							border-top: 0;

							.ttshop_myorderconleft {
								float: left;
								width: 50%;
								min-height: 112px;
								padding: 16px 20px 16px 10px;
								box-sizing: border-box;

								.ttshop_orderimg {
									float: left;
									width: 80px;
									height: 80px;
									margin-right: 12px;

									img {
										display: block;
										width: 100%;
										height: 100%;
										object-fit: cover;
									}
								}

								.ttshop_ordertext {
									float: left;
									width: 205px;

									h5 {
										font-size: 12px;
										color: #333333;
										font-weight: 500;
										line-height: 18px;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 2;
										overflow: hidden;
										margin-bottom: 8px;
									}

									span {
										font-size: 12px;
										color: #999;
										margin-right: 5px;

										strong {
											font-weight: 400;
											font-size: 12px;
											color: #999;
										}
									}
								}
							}

							.ttshop_myorderdj {
								float: left;
								width: 11%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									margin-bottom: 8px;
									
									span {
										font-size: 12px;
										color: #333;
									}
								}
							}

							.ttshop_myorderdjer {
								border-right: 1px solid #ebebeb;
							}

							.ttshop_shr {
								float: left;
								width: 12%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;
								border-right: 1px solid #ebebeb;

								p {
									font-size: 12px;
									color: #333;
								}
							}

							.ttshop_zfzje {
								float: left;
								width: 16%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;
								border-right: 1px solid #ebebeb;

								p {
									font-weight: 500;
									font-size: 12px;
									color: #333;
									margin-bottom: 8px;

									span {
										font-size: 12px;
										color: #333;
									}
								}

								strong {
									font-size: 12px;
									color: #333;
									font-weight: 400;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										color: #ff0e25;
									}
								}
							}

							// .ttshop_qbzt {
							//   float: left;
							//   width: 15%;
							//   text-align: center;
							//   padding-top: 16px;
							//   min-height: 138px;
							//   box-sizing: border-box;
							//   border-right: 1px solid #ebebeb;
							//   .ttshop_wfk {
							//     font-size: 12px;
							//     color: #ff8500;
							//     margin-bottom: 2px;
							//   }
							//   .ttshop_cancel {
							//     font-size: 12px;
							//     color: #999;
							//     margin-bottom: 2px;
							//   }
							//   .ttshop_over {
							//     font-size: 12px;
							//     color: #333;
							//     margin-bottom: 2px;
							//   }
							//   strong {
							//     font-size: 12px;
							//     color: #ff0e25;
							//     font-weight: 400;
							//     cursor: pointer;
							//   }
							// }

							.ttshop_caozuo {
								float: left;
								width: 16%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;
								border-right: 1px solid #ebebeb;

								.ttshop_ljzf {
									display: block;
									width: 72px;
									height: 24px;
									border: 1px solid #ff3346;
									background: #fff0f1;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #ff0e25;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}

								.ttshop_cztext {
									font-size: 12px;
									color: #333;
									margin-bottom: 8px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										color: #ff0e25;
									}
								}

								.ttshop_hg {
									display: block;
									width: 72px;
									height: 24px;
									background: #ebebeb;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #999;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										background: #ff0e25;
										color: #fff;
									}
								}

								.ttshop_queren {
									display: block;
									width: 72px;
									height: 24px;
									background: #ff0e25;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #fff;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}
							}
						}
					}

					.ttshop_caozuos {
						float: right;
						width: 24%;
						text-align: center;
						padding-top: 16px;
						min-height: 112px;
						box-sizing: border-box;
						border-right: 1px solid #ebebeb;
						border-bottom: 1px solid #ebebeb;

						.ttshop_cztexts {
							font-size: 12px;
							color: #ff0e25;
							margin-bottom: 8px;
						}

						.ttshop_ljzf {
							display: block;
							width: 72px;
							height: 24px;
							border: 1px solid #ff3346;
							background: #fff0f1;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #ff0e25;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
						}

						.ttshop_cztext {
							font-size: 12px;
							color: #333;
							margin-bottom: 8px;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							&:hover {
								color: #ff0e25;
							}
						}

						.ttshop_hg {
							display: block;
							width: 72px;
							height: 24px;
							background: #ebebeb;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #999;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							&:hover {
								background: #ff0e25;
								color: #fff;
							}
						}

						.ttshop_queren {
							display: block;
							width: 72px;
							height: 24px;
							background: #ff0e25;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #fff;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
						}
					}
				}

				.ttshop_myorderpage {
					width: 100%;
					margin-top: 32px;

					.ttshop_pages {
						float: right;
					}
				}
			}
		}
	}

	.ttshop_pay {
		.pay-title {
			width: 100%;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.pay-qrcode {
			width: 200px;
			height: 200px;
		}
	}
</style>
